import React from 'react';

// Utils
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import SCOPE from '../../utils/gate/scope';
import withAuth from '../../utils/hocs/withAuth';
import withPermission from '../../utils/hocs/withPermission';
import withSidebar from '../../utils/hocs/withSidebar';

// Services
import useInventoryService from '../../services/inventoryService';

// Components
import PageWrapper from '../../components/layout/PageWrapper/PageWrapper';
import Yields from '../../components/views/establishment/Yields/Yields';
import TableSkeleton from '../../components/views/establishment/Stocks/TableSkeleton';

function CampYields() {
  const { t } = useTranslation();

  const { getProducts } = useInventoryService();

  const { data: products, isFetching } = useQuery('getProducts', () => getProducts({ type: 'CAMP' }));

  return (
    <PageWrapper
      title={t('yields.title.camps')}
      hasWhiteWrapper
    >
      {isFetching ? (
        <TableSkeleton />
      ) : (
        <Yields
          products={products?.data?.products}
          type="camps"
        />
      )}
    </PageWrapper>
  );
}

CampYields.propTypes = {};

export default withAuth(
  withPermission(
    withSidebar(CampYields),
    {
      scopes: [SCOPE.get_ownEst_inventory],
    },
  ),
);
